import { Flex, Box, Text, Badge } from '@flodesk/grain';

type EmailCardProps = {
  title: string;
  imageUrl: string;
  badge: string;
};

export function EmailCard({ title, imageUrl, badge }: EmailCardProps) {
  return (
    <Flex
      direction="column"
      backgroundColor="#ffffff"
      radius="10px"
      shadow="s"
      overflow="hidden"
      width="342px"
    >
      <Box height="339px" overflow="hidden">
        <img
          src={imageUrl}
          alt={title}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>
      <Flex direction="column" paddingX="l2" paddingTop="m" paddingBottom="l2" rowGap="s">
        <Text size="m" weight="regular" color="#241a17">
          {title}
        </Text>
        <Badge variant="neutral">{badge}</Badge>
      </Flex>
    </Flex>
  );
}
